import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = {
  class: "design",
  id: "design"
}
const _hoisted_3 = { class: "container content-section" }
const _hoisted_4 = { class: "flex-container" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-6\"><div class=\"feature-box\"><h2 class=\"title\">Astounding Design</h2><p class=\"action-text\"> We take a very meticulous approach to design. We strive to create the most impressive visual design whether it’s for a website, mobile application or even something for print. You can be sure that form goes hand in hand with functionality. </p><p class=\"action-text\"> Our designs are modern and ready for high resolution devices, so no matter when you look our graphics will be sharp and sleek. </p><a href=\"#services\" class=\"btn normal\">Learn More</a></div></div>", 1)
const _hoisted_6 = { class: "col-12 col-md-6 feature-image" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("img", {
              src: require('@/assets/img/showcase1.jpg'),
              alt: ""
            }, null, 8, ["src"])
          ])
        ])
      ])
    ])
  ]))
}